import React from "react";
import { Input } from "antd";
import "./DefaultInput.css";

interface IDefaultInput {
	label?: string;
	placeholder?: string;
	width?: number;
	height?: number;
	value?: any;
	onChange?: (value: any) => void;
	allowClear?: any;
	className?: any;
	prefix?: any;
	suffix?: any;
	addonBefore?: any;
	type?: "text" | "password" | "number";
	required?: boolean;
	disabled?: boolean;
	ref?: any;
	min?: number;
	underLabel?: string;
	onBlur?: any;
	name?: string;
	labelClass?: string;
}

const DefaultPasswordInput = ({
	label,
	placeholder,
	width,
	value,
	height,
	onChange,
	allowClear,
	className,
	prefix,
	suffix,
	type = "text",
	addonBefore,
	required,
	disabled = false,
	ref,
	min,
	underLabel,
	onBlur,
	name,
	labelClass = "w-42",
}: IDefaultInput) => {
	return (
		<div className="flex flex-col items-start ">
			<label className={labelClass}>{label}</label>
			{underLabel && (
				<label className="w-42 " style={{ fontSize: 12 }}>
					{underLabel}
				</label>
			)}
			<Input.Password
				style={width && height ? { width: width, height: height } : {}}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				allowClear={allowClear}
				className={`default-input ${className}`}
				prefix={prefix}
				suffix={suffix}
				addonBefore={addonBefore}
				required={required}
				disabled={disabled}
				min={min}
				ref={ref}
				onBlur={onBlur}
				name={name}
			/>
		</div>
	);
};

export default DefaultPasswordInput;
